/**
 * TanStack Router Configuration
 *
 * Main router instance with type-safe configuration.
 * Uses file-based routing with the TanStackRouterVite plugin.
 *
 * Auth state is passed via router context to enable route guards
 * to check authentication status in beforeLoad hooks.
 */

import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import type { User } from "./stores/authStore";

// Router context type for auth state access in route guards
export interface RouterContext {
  auth: {
    isAuthenticated: boolean;
    isLoading: boolean;
    user: User | null;
  };
}

// Create the router instance with context
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
  context: {
    auth: {
      isAuthenticated: false,
      isLoading: true,
      user: null,
    },
  },
});

// Register the router for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
